import { ResponseGridController } from '../controller/ResponseGridController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { ResponseConstants } from '../ResponseConstants';

export class ResponseGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ResponseGridController,
    });
  }
  injectDependencies(dependencies: any) {
    dependencies.responseConstants = new ResponseConstants(dependencies.translateFn);
    super.injectDependencies(dependencies);
  }
}
